import { render, staticRenderFns } from "./model_tag.vue?vue&type=template&id=4d6d9050&scoped=true"
import script from "./model_tag.vue?vue&type=script&lang=ts"
export * from "./model_tag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d9050",
  null
  
)

export default component.exports